module.exports = __webpack_public_path__ + "img/yellow-porsche.47858f02.jpg";